// Extracted from Register.tsx so the account-gate validation is unit-testable.
import { z } from 'zod';

// GS-22: Enhanced name validation to prevent invalid names like "."
export const registerSchema = z.object({
  fullName: z.string()
    .min(1, 'Full name is required')
    .min(2, 'Name is too short')
    .refine(
      (name) => /[a-zA-Z]{2,}/.test(name),
      'Name must contain at least 2 letters'
    ),
  email: z.string().min(1, 'Email is required').email('Invalid email'),
  countryCode: z.string().regex(/^\+\d{1,4}$/, 'Select a valid country code'),
  phone: z
    .string()
    .min(1, 'Phone is required'),
  password: z
    .string()
    .min(1, 'Password is required')
    .min(8, 'Password must be at least 8 characters')
    .regex(/[a-zA-Z]/, 'Password must contain at least one letter')
    .regex(/[0-9]/, 'Password must contain at least one number'),
  confirmPassword: z.string().min(1, 'Please confirm your password'),
  agree: z.boolean().refine(v => v === true, {
    message: 'You must agree to the Terms of Service and Privacy Policy',
  }),
}).refine((data) => data.password === data.confirmPassword, {
  path: ['confirmPassword'],
  message: 'Passwords do not match',
}).superRefine((data, ctx) => {
  const digits = data.phone.replace(/\D/g, '');
  // North America requires exactly 10 digits
  if (data.countryCode === '+1') {
    if (digits.length !== 10) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['phone'],
        message: 'Enter a valid 10-digit phone number',
      });
    }
  } else {
    // Other countries: 7-15 digits
    if (digits.length < 7 || digits.length > 15) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['phone'],
        message: 'Enter a valid phone number (7-15 digits)',
      });
    }
  }
});

